import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Privacy() {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl p-8">
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-sm text-blue-600 hover:text-blue-800">
            <ArrowLeft className="w-4 h-4 mr-1" />
            Voltar para Home
          </Link>
        </div>

        <h1 className="text-3xl font-bold text-slate-900 mb-8">Política de Privacidade</h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="mb-4">Última atualização: {new Date().toLocaleDateString()}</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">1. Introdução</h2>
          <p className="mb-4">
            A MarcAI ("nós", "nosso") respeita a sua privacidade e está comprometida em proteger os seus dados pessoais. 
            Esta política de privacidade irá informá-lo sobre como cuidamos dos seus dados quando você visita nosso aplicativo 
            e informa sobre seus direitos de privacidade e como a lei o protege.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">2. Dados que Coletamos</h2>
          <p className="mb-4">
            Podemos coletar, usar, armazenar e transferir diferentes tipos de dados pessoais sobre você, que agrupamos da seguinte forma:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Dados de Identidade: inclui nome, sobrenome, nome de usuário ou identificador similar.</li>
            <li>Dados de Contato: inclui endereço de e-mail e números de telefone.</li>
            <li>Dados Técnicos: inclui endereço de protocolo de internet (IP), seus dados de login, tipo e versão do navegador, configuração e localização do fuso horário.</li>
            <li>Dados de Uso: inclui informações sobre como você usa nosso aplicativo.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">3. Como Usamos Seus Dados</h2>
          <p className="mb-4">
            Só usaremos seus dados pessoais quando a lei nos permitir. Mais comumente, usaremos seus dados pessoais nas seguintes circunstâncias:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Onde precisamos executar o contrato que estamos prestes a celebrar ou celebramos com você.</li>
            <li>Onde for necessário para nossos interesses legítimos (ou de terceiros) e seus interesses e direitos fundamentais não se sobreponham a esses interesses.</li>
            <li>Onde precisamos cumprir uma obrigação legal ou regulatória.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">4. Segurança de Dados</h2>
          <p className="mb-4">
            Estabelecemos medidas de segurança adequadas para evitar que seus dados pessoais sejam acidentalmente perdidos, usados ou acessados de forma não autorizada, alterados ou divulgados.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">5. Contato</h2>
          <p className="mb-4">
            Se você tiver alguma dúvida sobre esta política de privacidade ou nossas práticas de privacidade, entre em contato conosco:
          </p>
          <p className="font-medium">
            Email: marcoamlevy@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
}
